module.exports = __webpack_public_path__ + "img/fr_Ecran 2.967f37cb.png";